import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { WeeklyResultByStoreReportService } from '../weekly-result-by-store-report/weekly-result-by-store-report.service';
import { ShopinfoService } from '../../system/shopinfo/shopinfo.service';
import { ShopinfoModel } from '../../system/shopinfo/model/shopinfo.model';
import { DepartmentService } from '../../system/department/department.service';
import { FormsModule } from '@angular/forms';
import moment from 'moment';
import { AttendanceExceptionReportService } from './attendance-exception-report.service';
import { UserInfoModel } from 'src/app/common/models/user-info.model';
import { AppConstants } from 'src/app/common/app.constants';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-attendance-exception-report',
  standalone: false,
  templateUrl: './attendance-exception-report.component.html',
  styleUrl: './attendance-exception-report.component.scss'
})
export class AttendanceExceptionReportComponent implements OnInit {

  user: UserInfoModel | undefined;
  title: string = "Attendance Exception";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  selectedYear: any;
  weeks: any[] = [];
  departmentListData: any = [];
  financialYears: any[] = [];
  years: number[] = [];
  curFinYear!: string;
  daysOfWeek: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  hours: string[] = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  fromHour: string = '00';
  toHour: string = '00';
  shop_id: any;
  shop_name: any;
  departmentValidationMessage: any;
  departmentSelectionInvalid: boolean = false;
  resetButtonEnabled: boolean = false;
  shopListData: any = [];
  filteredShopList: any[] = [];
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private attendanceExceptionReportService: AttendanceExceptionReportService,
    private snackBarService: SnackBarService,
    private ShopinfoService: ShopinfoService,
    private departmentService: DepartmentService,
    private permissionService: PermissionService,
    public dialog: MatDialog,) {

    const today = new Date();
    this.editForm = this.builder.group({
      period_from: this.builder.control(today, Validators.required),
      period_to: this.builder.control(today, Validators.required),
      // shop_id: this.builder.control({ id: null, name: 'ALL', code: 'ALL' }, [Validators.required, this.shopValidator.bind(this)]),
      shop_id: this.builder.control({ id: null, name: 'ALL', code: 'ALL' }, [Validators.required, this.shopValidator.bind(this)]),

    }, { validators: this.dateRangeWithinOneYearValidator() }); // <-- add validator here

    this.currentYear = new Date().getFullYear();

    // Automatically save to sessionStorage when form values change
    this.editForm.valueChanges.subscribe(() => {
      this.saveToSessionStorage();
    });

    this.shopList();
    this.permission = permissionService.getPagePermission("attendance-exception");
    console.log(this.permission);
  }

  ngOnInit(): void {
    this.shopList();
    let sesUser = sessionStorage.getItem(AppConstants.SESSION_VAR_USER);
    this.user = (sesUser !== null) ? JSON.parse(sesUser) : undefined;
    console.log(this.user);

    // Add autocomplete filtering
    this.editForm.get('shop_id')?.valueChanges.subscribe(value => {
      this.filterShops();
    });
  }

  selectedDays(): string[] {
    const days = this.editForm.get('days')?.value;
    return Object.keys(days).filter(day => days[day]);
  }

  shopList(): void {
    let requestData = {
      search: {
        filters: {
          filter: [],
          scope: { offset: 0, limit: 1000000 }
        },
        sort: [{ column: "shop.name", order: "ASC" }]
      }
    }

    this.attendanceExceptionReportService.getShopList(requestData).subscribe({
      next: (response: any) => {
        // Add "ALL" option at the beginning
        const allOption = { id: null, name: 'ALL', code: 'ALL' };
        this.shopListData = [allOption, ...response.data.shops];
        this.filteredShopList = this.shopListData.slice(); // Initialize with copy including ALL
      },
      error: (error: any) => {
        console.error('Error fetching shops:', error);
      }
    });
  }

  hourRangeValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const from = group.get('fromHour')?.value;
      const to = group.get('toHour')?.value;

      if (from != null && to != null && from > to) {
        return { invalidHourRange: true };
      }
      return null;
    };
  }

  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }

  sortOptions = [
    { value: 'shop_name', label: 'Shop Name' },
    { value: 'this_year_this_week_sales', label: 'This Year Sales' },
    { value: 'last_year_this_week_sales', label: 'Last Year Sales' },
    { value: 'this_week_cust_orders', label: 'This Year Customer Orders' },
    { value: 'last_year_cus_order', label: 'Last Year Customer Orders' },
    { value: 'this_week_labour_cost', label: 'This Year Labour Cost' },
    { value: 'last_year_this_week_labour_cost', label: 'Last Year Labour Cost' },
  ];

  sortOrderOptions = [
    { value: 'asc', label: 'Ascending' },
    { value: 'desc', label: 'Descending' }
  ];

  saveToSessionStorage(): void {
    const selectedDepartmentIds = this.departmentListData
      .filter((shop: any) => shop.selected)
      .map((shop: any) => shop.item.id);

    const departmentIds = selectedDepartmentIds.length > 0 ? selectedDepartmentIds : [];
    if (selectedDepartmentIds.length > 0) {
      this.resetButtonEnabled = true;
    } else {
      this.resetButtonEnabled = false;
    }

    const reportData = {
      year: this.editForm.get('year')?.value,
      weekNo: this.editForm.get('week_no')?.value,
      shopId: departmentIds,
      sortBy: this.editForm.get('sort_by')?.value,
      sortDir: this.editForm.get('sort_order')?.value,
      isExport: 0
    };

    sessionStorage.setItem('hourlySalesReportData', JSON.stringify(reportData));
  }

  loadFromSessionStorage(): void {
    const savedData = sessionStorage.getItem('weeklyStoreReportData');
    if (savedData) {
      const reportData = JSON.parse(savedData);

      this.editForm.patchValue({
        year: reportData.year,
        week_no: reportData.weekNo,
        sort_by: reportData.sortBy,
        sort_order: reportData.sortDir
      }, { emitEvent: false });

      if (reportData.shopId && reportData.shopId.length > 0) {
        this.departmentListData.forEach((shop: any) => {
          shop.selected = reportData.shopId.includes(shop.item.id);
        });
      } else {
        this.departmentListData.forEach((shop: any) => shop.selected = false);
      }

      if (reportData.year) {
        this.onYearChange();
      }
    }
  }

  onYearChange(): void {
    this.selectedYear = this.editForm.get('year')?.value;
    console.log('Selected Year:', this.selectedYear);

    const selectedFinYear = this.financialYears.find(fy => fy.year === this.selectedYear);

    if (selectedFinYear) {
      this.weeks = selectedFinYear.weeks.map((week: any) => ({
        ...week,
        displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
      }));

      if (this.weeks.length > 0) {
        this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get('week_no')?.setValue(null);
    }
  }

  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }

  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach(el => {
      if (el.selected) {
        count++;
      }
    })
    return sourceList.length + '/' + ((count > 0) ? (count) : 'ALL');
  }

  reset(sourceList: any[]): any {
    sourceList.forEach(el => {
      el.selected = false;
    });
  }

  shopValidator(control: AbstractControl) {
    if (!control.value) return { invalidShop: true };

    // Allow "ALL" option (with id: null)
    if (typeof control.value === 'object' && (control.value.id === null || control.value.name === 'ALL')) {
      return null;
    }

    if (typeof control.value === 'object' && this.shopListData.some((shop: { id: any; }) => shop.id === control.value.id)) {
      return null;
    }
    if (typeof control.value === 'string' && this.shopListData.some((shop: { name: any; }) => shop.name === control.value)) {
      return null;
    }
    return { invalidShop: true };
  }

  // Validator to ensure date range is <= 365 days
  dateRangeWithinOneYearValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const from = group.get('period_from')?.value;
      const to = group.get('period_to')?.value;
      if (from && to) {
        const fromDate = moment(from);
        const toDate = moment(to);
        if (toDate.diff(fromDate, 'days') >= 365) {
          return { dateRangeTooLong: true };
        }
      }
      return null;
    };
  }

  onShopSelectionChange(): void {
    this.saveToSessionStorage();
  }



  exportClicked(): void {
    if (this.editForm.invalid) {
      // Check for date range error
      if (this.editForm.errors && this.editForm.errors['dateRangeTooLong']) {
        let snackBarData: SnackBarData = {
          message: 'Please choose a date range shorter than 365 days.',
          title: 'Invalid Date Range',
          type: 'warn'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.editForm.markAllAsTouched();
      return;
    }
    this.IsDownloading = true;

    var rawDateFrom = this.editForm.get('period_from')?.value;
    var formattedDateFrom = moment(rawDateFrom).format('DD-MM-YYYY');
    var rawDateTo = this.editForm.get('period_to')?.value;
    var formattedDateTo = moment(rawDateTo).format('DD-MM-YYYY');
    const selectedShopId = this.editForm.get('shop_id')?.value;

    // Handle "ALL" option - if ALL is selected or shopId is null, pass null
    let shopId = null;
    if (selectedShopId && typeof selectedShopId === 'object') {
      shopId = selectedShopId.id; // This will be null for "ALL" option
    } else if (selectedShopId && selectedShopId !== 'ALL') {
      shopId = selectedShopId;
    }

    const reportData = {
      dateFrom: formattedDateFrom,
      dateTo: formattedDateTo,
      shopId: shopId  // Will be null when "ALL" is selected
    };

    if (reportData) {
      this.attendanceExceptionReportService.exportAttendanceExceptionReport(reportData).subscribe({
        next: (response: Blob) => {
          const reader = new FileReader();

          reader.onload = () => {
            try {
              const text = reader.result as string;
              const json = JSON.parse(text);

              if (json.status != 'SUCCESS') {
                let snackBarData: SnackBarData = {
                  message: json.message,
                  title: 'No Data!!!',
                  type: 'error'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }
            } catch (e) {
              const blob = new Blob([response], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'attendance-exception-report.csv';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.IsDownloading = false;
            }
          };

          reader.readAsText(response);
        },
        error: (error) => {
          console.error('Error fetching report:', error);
          this.IsDownloading = false;
        }
      });
    }
  }

  filterShops() {
    const value = this.editForm.get('shop_id')?.value;
    if (!value || value === '') {
      this.filteredShopList = this.shopListData.slice();
      return;
    }

    const filterValue = typeof value === 'string' ? value.toLowerCase() : (value?.name?.toLowerCase() || '');
    this.filteredShopList = this.shopListData.filter((shop: any) =>
      shop.name.toLowerCase().includes(filterValue)
    );
  }

  displayShop(shop: any): string {
    return shop && shop.name ? shop.name : '';
  }

  clearShop() {
    this.editForm.get('shop_id')?.setValue('');
    this.filteredShopList = this.shopListData.slice();
  }
}
